import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

/**
 * Requisitos OCR en comprobaciones (detalle de operación): tipo doc., país, caducidad, mayoría de edad.
 */
@Component({
	selector: 'app-operation-ocr-checks-requirements',
	imports: [ChecksComponent],
	templateUrl: './operation-ocr-checks-requirements.component.html',
	styleUrl: './operation-ocr-checks-requirements.component.scss',
})
export class OperationOcrChecksRequirementsComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;

	protected readonly checks: CHECK[] = [
		CHECK.OCR_DOCUMENT_TYPE,
		CHECK.COUNTRY,
		CHECK.EXPIRATED,
		CHECK.LEGAL_AGE,
	];
}
